import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { Language } from '../enum/EnumRepository';

export { Language };

function getDefaultLanguage(): Language {
  if (typeof window === 'undefined') {
  return Language.EN;
  }
  const savedLanguage = localStorage.getItem('app_language');
  if (savedLanguage && Object.values(Language).includes(savedLanguage as Language)) {
    return savedLanguage as Language;
  }
  const browserLanguage = navigator.language.toLowerCase();
  if (browserLanguage.startsWith('ko')) return Language.KR;
  if (browserLanguage.startsWith('ja')) return Language.EN;
  if (browserLanguage.startsWith('zh')) return Language.EN;
  return Language.EN;
}

interface LanguageState {
  language: Language;
  setLanguage: (language: Language) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set) => ({
      language: getDefaultLanguage(),
      setLanguage: (language: Language) => set({ language }),
    }),
    {
      name: 'app-language',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
